/* eslint-disable object-curly-newline */
import { get, post, patch } from 'store/http/httpAction';
import Enums from 'utils/EnumsManager';
import {
  SET_RULE_VALUE,
  SET_ALL_RULE_VALUE,
  SET_CRITERIA_LOGIC,
  ADD_CRITERIA,
  SET_ALL_CRITERIA,
  REMOVE_CRITERIA,
  SET_META_DATA_FIELDS,
  UPDATE_CRITERIA_BY_COLUMN,
  SET_META_CONDITIONS,
  SET_META_CONTEXT,
  SET_META_FIELDS_DATA,
  RESET_META_DATA,
  RESET_CRITERIA,
  SET_SIDER,
  RESET_SIDER,
  ADD_TRIGGER,
  REMOVE_TRIGGER,
  RESET_TRIGGER,
  SET_TRIGGER_META_OBJECT_OPTIONS,
  SET_TRIGGER_OBJECT_KEY,
  ADD_TRIGGER_ACTION,
  UPDATE_TRIGGER_ACTION_FILTER_VALUE,
  SET_ALL_TRIGGER_ACTION,
  REMOVE_SESSION_FILTER,
  RESET_RULES
} from './actionTypes';
import { formatSiderOptions, apiToCriterial } from '../utils/criterialUtils';
import { apiToActionValue } from '../utils/triggerUtils';
import { WorkFlowField } from '../models';

const { PhantomId } = Enums;

export const setRuleValue = (keyName, ruleValue) => ({
  type: SET_RULE_VALUE,
  payload: { keyName, ruleValue }
});

const setALLruleValue = ruleValues => ({
  type: SET_ALL_RULE_VALUE,
  payload: { ruleValues }
});

const resetRules = () => ({
  type: RESET_RULES
});

export const addCriteria = () => ({
  type: ADD_CRITERIA,
});

const setAllCriterias = allCriterias => ({
  type: SET_ALL_CRITERIA,
  payload: { allCriterias },
});

export const removeCriteria = displayNum => ({
  type: REMOVE_CRITERIA,
  payload: { displayNum }
});

export const setCriteriaLogic = logicText => ({
  type: SET_CRITERIA_LOGIC,
  payload: { logicText }
});

export const updateCriteriaByColumn = (columnKey, displayNum, columnValue) => ({
  type: UPDATE_CRITERIA_BY_COLUMN,
  payload: { columnKey, colmunNum: displayNum, columnValue },
});

const setMetaContext = metaContext => ({
  type: SET_META_CONTEXT,
  payload: { metaContext },
});

const setMetaDataFields = metaDataFields => ({
  type: SET_META_DATA_FIELDS,
  payload: { metaDataFields },
});

const setMetaConditions = metaConditions => ({
  type: SET_META_CONDITIONS,
  payload: { metaConditions }
});

const setMetaFieldsData = (fields, objectTypes) => ({
  type: SET_META_FIELDS_DATA,
  payload: { fields, objectTypes },
});

const resetMetaData = () => ({
  type: RESET_META_DATA,
});

export const setSiderData = (siderOptions, selectedcriteria, sessionNum = null) => ({
  type: SET_SIDER,
  payload: { siderOptions, selectedcriteria, sessionNum },
});

export const resetSiderData = () => ({
  type: RESET_SIDER,
});

export const resetCriteria = () => ({
  type: RESET_CRITERIA
});

export const addTrigger = () => ({
  type: ADD_TRIGGER,
});

export const delectTrigger = sessionNum => ({
  type: REMOVE_TRIGGER,
  payload: { sessionNum }
});

export const resetTrigger = () => ({
  type: RESET_TRIGGER,
});

export const setTriggerMetaObjectOptions = objectOptions => ({
  type: SET_TRIGGER_META_OBJECT_OPTIONS,
  payload: { objectOptions },
});

export const setTriggerObject = (sessionNum, objectKey) => ({
  type: SET_TRIGGER_OBJECT_KEY,
  payload: { sessionNum, objectKey }
});

export const addTriggerAction = sessionNum => ({
  type: ADD_TRIGGER_ACTION,
  payload: { sessionNum },
});

const setAllTriggerAction = (sessionValue, filtersValue) => ({
  type: SET_ALL_TRIGGER_ACTION,
  payload: { sessionValue, filtersValue }
});

export const updateTriggerActionFilterValue = (sessionNum, displayNum, updateValue, updateKey) =>({
  type: UPDATE_TRIGGER_ACTION_FILTER_VALUE,
  payload: { sessionNum, displayNum, updateValue, updateKey },
});

export const removeSessionFilter = (sessionNum, displayNum) => ({
  type: REMOVE_SESSION_FILTER,
  payload: { sessionNum, displayNum }
});

export const resetSelections = () => dispatch => {
  dispatch(resetCriteria());
  dispatch(resetTrigger());
  dispatch(resetMetaData());
};

export const reset = () => dispatch => {
  dispatch(resetRules());
  dispatch(resetSelections());
};

export const fetchCriteriaFields = code => dispatch => get(`/admin/workflow-context-meta/${code}`, {}, dispatch).then(data => {
  if (data) {
    const { context_attributes_meta, update_able_objects_meta } = data;
    if (_.isArray(context_attributes_meta) && !_.isEmpty(context_attributes_meta)) {
      const metaFields = context_attributes_meta.map(meta => new WorkFlowField(meta));
      dispatch(setMetaDataFields(metaFields));
    }
    if (_.isArray(update_able_objects_meta) && !_.isEmpty(update_able_objects_meta)) {
      dispatch(setTriggerMetaObjectOptions(update_able_objects_meta));
    }
  }
});

export const fetchContextMeta = workFlowId => dispatch => get('/admin/workflow-context-meta-list', {}, dispatch).then(data => {
  if (_.isArray(data)) {
    dispatch(setMetaContext(data));
    // set default value to get the other meta data
    if (!_.isEmpty(data)) {
      dispatch(setRuleValue('ruleWhen', data[0].code));
      dispatch(fetchCriteriaFields(data[0].code));
      // No matter workFlowId is === PhantomId, we need to fetch the criteria Fields
      // if (workFlowId === PhantomId) {
      //   dispatch(fetchCriteriaFields(data[0].code));
      // }
    }
  }
});

export const fetchCriteriaConditions = () => dispatch => get('/admin/workflow-datatype-meta', {}, dispatch).then(data => {
  if (data) {
    dispatch(setMetaConditions(data));
  }
});

const setWorkFlowDetailCriteria = condition => (dispatch, getState) => {
  const store = getState();
  const { criteriaMetaData } = store.setup.workFlow.metaData;
  const { fields } = criteriaMetaData;
  const { logic, sub_conditions } = condition;
  dispatch(setCriteriaLogic(logic));
  const parsedCriterial = sub_conditions.map(c => apiToCriterial(c, fields || []));
  dispatch(setAllCriterias(parsedCriterial));
};

const setWorkFlowDetailAction = actions => (dispatch, getState) => {
  const store = getState();
  const { triggerMeta } = store.setup.workFlow.metaData;
  const { objectOptions, fieldsData } = triggerMeta;
  const sessionValue = [];
  let filtersValue = {};
  // before setting the trigger value, it needs to get the meta fields data to decide the field type and parse the date time value.
  let metaFields = _.cloneDeep(fieldsData);
  const promiseFields = Promise.all(objectOptions.map(object => {
    const field = object.object_type;
    if (!field || !metaFields) return {};
    return new Promise(async (resolve, reject) => {
      if (_.isEmpty(metaFields[field])) {
        let value = [];
        await dispatch(fetchFieldsByType(field, d => value = d));
        resolve({ field, value });
      }
      resolve({ field, value: metaFields[field] });
    });
  }));
  promiseFields.then(resolveValue => {
    resolveValue.forEach(v => {
      metaFields = {
        ...metaFields,
        [v.field]: v.value,
      };
    });
    actions.forEach((action, index) => {
      const selectedObject = objectOptions.find(object => object.object_key === action.action_detail.object_key);
      const selectedObjectType = selectedObject && selectedObject.object_type ? selectedObject.object_type : '';
      sessionValue.push({
        sessionNum: index + 1,
        triggerValue: {
          triggerType: action.action_type,
          objectKey: action.action_detail.object_key,
        }
      });
      filtersValue = {
        ...filtersValue,
        [index + 1]: apiToActionValue(action.action_detail.update_fields, metaFields[selectedObjectType]),
      };
    });
    dispatch(setAllTriggerAction(sessionValue, filtersValue));
  });
};

export const fetchWorkFlowDetials = workFlowId => dispatch => get(`/admin/workflow-rules/${workFlowId}`, {}, dispatch).then(async data => {
  if (data && !_.isEmpty(data.data)) {
    const {
      name,
      description,
      op_code,
      condition,
      actions
    } = data.data;
    
    // set the value of Rule Setup
    dispatch(setALLruleValue({
      ruleName: name,
      ruleDescription: description,
      ruleWhen: op_code
    }));
    await dispatch(fetchCriteriaFields(op_code));

    // set the Value of Criteria
    if (!_.isEmpty(condition)) {
      dispatch(setWorkFlowDetailCriteria(condition));
    }

    // set the Value of Trigger
    if (!_.isEmpty(actions)) {
      dispatch(setWorkFlowDetailAction(actions));
    }
  }
});

export const fetchWorkFlowData = workFlowId => async dispatch => {
  await dispatch(fetchContextMeta(workFlowId));
  await dispatch(fetchCriteriaConditions());
  if (workFlowId !== PhantomId) {
    dispatch(fetchWorkFlowDetials(workFlowId));
  }
};

export const fetchRightSideData = (url, filter, sessionNum = null) => dispatch => get(url, {}, dispatch).then(data => {
  if (data) {
    dispatch(setSiderData(formatSiderOptions(data, filter.type), filter, sessionNum));
  }
});

export const fetchFieldsByType = (objectType, cb) => dispatch =>
  get(`/admin/metadata/object/${objectType}`, {}, dispatch).then(data => {
    const main = data && data.main && _.isArray(data.main.data) ? data.main.data : [];
    const cstm = data && data.cstm && _.isArray(data.cstm.data) ? data.cstm.data : [];
    const columns = [...main, ...cstm];
    const fields = _.sortBy(columns, c => c.field_label);
    dispatch(setMetaFieldsData(fields, objectType));
    if (_.isFunction(cb)) {
      cb(fields);
    }
  });

export const addWorkFlow = (value, cb) => dispatch =>
  post('/admin/workflow-rules', value, dispatch).then(data => {
    if (data && _.isFunction(cb)) {
      cb();
    }
  });

export const updateWorkFlow = (value, workFlowId, cb) => dispatch =>
  patch(`/admin/workflow-rules/${workFlowId}`, value, dispatch).then(data => {
    if (data && _.isFunction(cb)) {
      cb();
    }
  });



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/action.js